import React from 'react';
import ARROW from 'assets/img/play_arrow.svg';
import ARROW_BLUE from 'assets/img/play_arrow_blue.svg';
import { CustomIcon, RoundChart } from '../../../../common';
import './style.scss';

export const TechnologiesBlock = ({ openWhyPopup, isDarkTheme }) => (
  <div className="technologies_block">
    <RoundChart color="blue" percent={75} title="FIBER" />
    <RoundChart color="blue" percent={100} title="BROADBAND" />
    <RoundChart color="blue" percent={41} title="MOBILE" />
    <div className="technologies_block_wrapper">
      <RoundChart color="blue" percent={2} title="NOT COVERED" />
      <p onClick={() => openWhyPopup()}><CustomIcon
        src={isDarkTheme ? ARROW_BLUE : ARROW}
        width="10px"
        height="10px"
        rotate="270"
      />Why?
      </p>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/view/screens/Project/components/TechnologiesBlock/index.js